import React from 'react';
import { ClassAssembly7C2026 } from '../views';


const ClassAssemblyPage = () => {
    return <ClassAssembly7C2026/>;
  };
  
  export default ClassAssemblyPage;